// extracted by mini-css-extract-plugin
export default {"row21":"TrainingForm_row21__WIH33","row11":"TrainingForm_row11__bwUuT"};